export default function getFunctionDisplayName(f) {
    var _a;
    return (_a = f.displayName) !== null && _a !== void 0 ? _a : f.name;
}
